module.exports = __webpack_public_path__ + "img/research.5f2f5dad.svg";